// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__eL6hL","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__XJ6Vs"};